import { render, staticRenderFns } from "./SnackbarMessage.vue?vue&type=template&id=57b98b5c"
import script from "./SnackbarMessage.vue?vue&type=script&lang=js"
export * from "./SnackbarMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports